// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status_video {
  position: absolute;
  top: 15px;
  left: 0px;
  padding: 4px 6px;
  color: white !important;
}
.h-100 {
  height: 100% !important;
}
.w-100per {
  width: 100% !important;
}
.jus-around {
  justify-content: space-around !important;
}
.jus-between {
  justify-content: space-between !important;
}
.mr-10 {
  margin-right: 10px !important;
}
.mt-1r {
  margin-top: 1rem !important;
}
.max-w-none {
  max-width: none !important;
}
.w-120 {
  width: 120px !important;
}
.w-140 {
  width: 140px !important;
}
.w-160 {
  width: 160px !important;
}
.loading-spin {
  width: 100vw !important;
  height: 50vh !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.card-container {
  height: 170px !important;
  min-height: 170px !important;
  width: 100% !important;
  position: relative !important;
}
.card-img {
  object-fit: contain !important;
  cursor: pointer !important;
}
.card-duration {
  position: absolute !important;
  bottom: 5px !important;
  right: 0 !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  padding: 4px 6px !important;
}
.btn-more {
  float: right;
  color: black;
}
.display-tag {
  position: relative;
  overflow: hidden;
}
.float-r {
  float: right;
}
.lineHeight {
  line-height: 30pt;
}
.opac-08 {
  opacity: 0.8;
}
.cursor-pointer {
  cursor: pointer;
}
.container-empty {
  width: 100vw !important;
  height: 50vh !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.list-subtitle {
  overflow-x: hidden;
  height: 90%;
  overflow-y: auto;
}
.list-subtitle::-webkit-scrollbar {
  display: none;
}
.list-scene {
  overflow-x: hidden;
  max-height: 80%;
  overflow-y: auto;
}
.list-scene::-webkit-scrollbar {
  display: none;
}
.card-subtitle {
  background-color: #7c82bb;
  margin-top: 10px;
  min-height: 40px;
  border-radius: 5px;
}
.card-subtitle-select {
  background-color: #b592d5;
  margin-top: 10px;
  min-height: 40px;
  border-radius: 5px;
}
.tab-scenario .ant-tabs-tab-active {
  background: #1677ff !important;
  color: white !important;
}
.tab-scenario .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: white !important;
}
.tab-scenario .ant-tabs-tab-active:hover {
  background: #4096ff !important;
}
.ant-tabs-tab {
  background: white !important;
}
.tab-scenario .ant-tabs-nav {
  margin: 0 !important;
}
.tab-scenario {
  width: 100% !important;
}
.topic-color {
  color: #21134f !important;
}
.brebadcrumb-back {
  font-size: 16pt !important;
  color: #21134f !important;
}
.brebadcrumb-back:hover {
  opacity: 0.9;
}
.brebadcrumb-title {
  font-size: 14pt !important;
  color: #21134f !important;
}
.mt-05 {
  margin-top: 5px !important;
}
.video-detail-container {
  background: #e2e2e8 !important;
  height: 550px !important;
  border-radius: 4px !important;
  padding: 10px 10px 10px 10px !important;
}
.scenario-group {
  margin-bottom: 8px !important;
  width: 100% !important;
}
.detail-scenario {
  padding: 10px 10px 30px 30px !important;
}
.video-tag-selected:hover {
  background: #55acee9e !important;
  color: white;
}
.video-tag-unselected:hover {
  background: #55acee !important;
  color: white;
}
.ant-table-cell-row-hover {
  cursor: pointer ;
}
`, "",{"version":3,"sources":["webpack://./src/views/videos/styles/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AACF;AAEA;EACE,uBAAA;AAAF;AAGA;EACE,sBAAA;AADF;AAIA;EACE,wCAAA;AAFF;AAKA;EACE,yCAAA;AAHF;AAMA;EACE,6BAAA;AAJF;AAOA;EACE,2BAAA;AALF;AAQA;EACE,0BAAA;AANF;AASA;EACE,uBAAA;AAPF;AAUA;EACE,uBAAA;AARF;AAWA;EACE,uBAAA;AATF;AAYA;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;AAVF;AAaA;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,6BAAA;AAXF;AAcA;EACE,8BAAA;EACA,0BAAA;AAZF;AAgBA;EACE,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,+CAAA;EACA,uBAAA;EACA,2BAAA;AAdF;AAiBA;EACE,YAAA;EACA,YAAA;AAfF;AAkBA;EACE,kBAAA;EACA,gBAAA;AAhBF;AAmBA;EACE,YAAA;AAjBF;AAoBA;EACE,iBAAA;AAlBF;AAqBA;EACE,YAAA;AAnBF;AAsBA;EACE,eAAA;AApBF;AAuBA;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;AArBF;AAyBA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAvBF;AA0BA;EACE,aAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAzBF;AA4BA;EACE,aAAA;AA1BF;AA8BA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA5BF;AA+BA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA7BF;AAgCA;EACE,8BAAA;EACA,uBAAA;AA9BF;AAgCA;EACE,uBAAA;AA9BF;AAiCA;EACE,8BAAA;AA/BF;AAkCA;EACE,4BAAA;AAhCF;AAmCA;EACE,oBAAA;AAjCF;AAoCA;EACE,sBAAA;AAlCF;AAqCA;EACE,yBAAA;AAnCF;AAsCA;EACE,0BAAA;EACA,yBAAA;AApCF;AAwCA;EAGE,YAAA;AAxCF;AA2CA;EACE,0BAAA;EACA,yBAAA;AAzCF;AA4CA;EACE,0BAAA;AA1CF;AA6CA;EACE,8BAAA;EACA,wBAAA;EACA,6BAAA;EACA,uCAAA;AA3CF;AA8CA;EACE,6BAAA;EACA,sBAAA;AA5CF;AA+CA;EACE,uCAAA;AA7CF;AAgDA;EACE,gCAAA;EACA,YAAA;AA9CF;AAiDA;EACE,8BAAA;EACA,YAAA;AA/CF;AAkDA;EACE,gBAAA;AAhDF","sourcesContent":[".status_video {\n  position: absolute;\n  top: 15px;\n  left: 0px;\n  padding: 4px 6px;\n  color: white !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.w-100per {\n  width: 100% !important;\n}\n\n.jus-around {\n  justify-content: space-around !important;\n}\n\n.jus-between {\n  justify-content: space-between !important;\n}\n\n.mr-10 {\n  margin-right: 10px !important;\n}\n\n.mt-1r {\n  margin-top: 1rem !important;\n}\n\n.max-w-none {\n  max-width: none !important;\n}\n\n.w-120 {\n  width: 120px !important;\n}\n\n.w-140 {\n  width: 140px !important;\n}\n\n.w-160 {\n  width: 160px !important;\n}\n\n.loading-spin {\n  width: 100vw !important;\n  height: 50vh !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.card-container {\n  height: 170px !important;\n  min-height: 170px !important;\n  width: 100% !important;\n  position: relative !important;\n}\n\n.card-img {\n  object-fit: contain !important;\n  cursor: pointer !important;\n  // border-bottom: 1px solid #ccc !important;\n}\n\n.card-duration {\n  position: absolute !important;\n  bottom: 5px !important;\n  right: 0 !important;\n  background-color: rgb(0 0 0/0.6) !important;\n  color: white !important;\n  padding: 4px 6px !important;\n}\n\n.btn-more {\n  float: right;\n  color: black;\n}\n\n.display-tag {\n  position: relative;\n  overflow: hidden;\n}\n\n.float-r {\n  float: right;\n}\n\n.lineHeight {\n  line-height: 30pt;\n}\n\n.opac-08 {\n  opacity: 0.8;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.container-empty {\n  width: 100vw !important;\n  height: 50vh !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n//video display\n.list-subtitle {\n  overflow-x: hidden;\n  height: 90%;\n  overflow-y: auto;\n}\n\n.list-subtitle::-webkit-scrollbar {\n  display: none;\n}\n\n.list-scene {\n  overflow-x: hidden;\n  max-height: 80%;\n  overflow-y: auto;\n}\n\n.list-scene::-webkit-scrollbar {\n  display: none;\n}\n\n//subtitle\n.card-subtitle {\n  background-color: #7c82bb;\n  margin-top: 10px;\n  min-height: 40px;\n  border-radius: 5px;\n}\n\n.card-subtitle-select {\n  background-color: #b592d5;\n  margin-top: 10px;\n  min-height: 40px;\n  border-radius: 5px;\n}\n\n.tab-scenario .ant-tabs-tab-active {\n  background: #1677ff !important;\n  color: white !important;\n}\n.tab-scenario .ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: white !important;\n}\n\n.tab-scenario .ant-tabs-tab-active:hover {\n  background: #4096ff !important;\n}\n\n.ant-tabs-tab {\n  background: white !important;\n}\n\n.tab-scenario .ant-tabs-nav {\n  margin: 0 !important;\n}\n\n.tab-scenario {\n  width: 100% !important;\n}\n\n.topic-color {\n  color: #21134f !important;\n}\n\n.brebadcrumb-back {\n  font-size: 16pt !important;\n  color: #21134f !important;\n}\n\n\n.brebadcrumb-back:hover {\n  // font-size: 16pt !important;\n  // color: #21134f !important;\n  opacity: 0.9;\n}\n\n.brebadcrumb-title {\n  font-size: 14pt !important;\n  color: #21134f !important;\n}\n\n.mt-05 {\n  margin-top: 5px !important;\n}\n\n.video-detail-container {\n  background: #e2e2e8 !important;\n  height: 550px !important;\n  border-radius: 4px !important;\n  padding: 10px 10px 10px 10px !important;\n}\n\n.scenario-group {\n  margin-bottom: 8px !important;\n  width: 100% !important;\n}\n\n.detail-scenario {\n  padding: 10px 10px 30px 30px !important;\n}\n\n.video-tag-selected:hover {\n  background: #55acee9e !important;\n  color:white\n}\n\n.video-tag-unselected:hover {\n  background: #55acee !important;\n  color:white\n}\n\n.ant-table-cell-row-hover{\n  cursor: pointer ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
